import { CandidateOutreachSendMethod } from 'clients/CampaignsClient/CampaignsClient.types';
import { Candidate as PartialCandidate } from 'clients/SearchClient/SearchClient.types';
import type { default as Candidate } from 'model/Candidate';
import { type ReactNode } from 'react';
import { CandidateHistoryAction } from 'services/candidates/types';
import { CampaignJobboard } from 'shared/legacy/contexts/SelectedCampaignContext/SelectedCampaignContext.types';
import { Ats } from 'types/ats';
import { OutreachType } from 'types/outreach';

export type Conversation = {
  id: number;
  status: string;
  user: {
    id: number | string;
    firstName: string;
    lastName: string;
  };
  campaign: {
    name: string;
  };
  unreadCount: number;
  lastMessageDate: string | null;
  lastMessageFromRecruiter: boolean;
  candidateName: string;
  esPersonId: string;
  source: CampaignJobboard;
  conversationSource: CandidateOutreachSendMethod;
  candidate?: PartialCandidate;
};

export type ConversationResponseResult = {
  id: number;
  status: string;
  user: {
    id: number | string;
    first_name: string;
    last_name: string;
  };
  campaign: {
    name: string;
  };
  unread_count: number;
  last_message_date: string;
  last_message_from_recruiter: boolean;
  candidate_name: string;
  es_person_id: string;
  source: CampaignJobboard;
  conversation_source: CandidateOutreachSendMethod;
};

export type ConversationCacheKey = {
  cacheKey: string;
};

export type ConversationResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: ConversationResponseResult[];
};

export type ConversationPreviewResponse = ConversationResponseResult[];

export type ConversationPreview = {
  results: Conversation[];
  count: number;
};

export interface InboxConversationListProps {
  showFilters?: boolean;
  showTeamView?: boolean;
  conversations: Conversation[];
  isLoading: boolean;
}

export interface InboxConversationListHeaderProps {
  showTeamView?: boolean;
}

export interface InboxConversationListBodyProps {
  conversations: Conversation[];
}

export type InboxConversationItemData = {
  id: number;
  candidateName: string;
  author: string;
  campaign: string;
  action: CandidateHistoryAction;
  atsName?: Ats;
  unreadCount: number;
};

export interface InboxConversationItemProps {
  conversation: Conversation;
}

export type InboxContextProviderProps = {
  candidate: Candidate;
  children: ReactNode;
};

export enum InboxFilters {
  ALL = 'all',
  UNREAD = 'unread',
  SENT = 'sent',
}

export type InboxSelectedChannelProps = {
  channel: InboxEditorType;
};

export type InboxFooterStyles = {
  editorState: EditorState;
};

export type InboxBaseStyles = {
  editorState: EditorState;
};

export enum InboxExtraEditorOptions {
  Note = 'Note',
}

export const inboxEditorType = {
  ...OutreachType,
  ...InboxExtraEditorOptions,
} as const;

export type InboxEditorType = keyof typeof inboxEditorType;

export enum EditorState {
  Default,
  Expanded,
  Minimized,
}
